import React, { useState, useEffect, useContext } from "react";
import { Col, Image, Row } from "react-bootstrap";
import { Card, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import FalconLightBox from "../../common/FalconLightBox";
import APICall from "../../../services/apiCall";
import AppContext, { PublishAppContext } from "../../../context/Context";

const AccountInformation = ({ partnerDetails, setPartnerDetails }) => {
  const [loading, setLoading] = useState(false);

  const { loginUserDetails } = useContext(AppContext);

  //const { partnerDetails, setPartnerDetails } = useContext(PublishAppContext);

  useEffect(() => {
    setLoading(true);
    let params = {
      devid: loginUserDetails.parent_dev_id,
    };
    APICall.servertrip("GET", "partner_details_user", loginUserDetails, params).then(
      (res) => {
        setPartnerDetails(res.data.items[0]);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        setLoading(false);
        toast.error(resMessage);
      }
    );
  }, []);

  return (
    <div>
      <Card className="mb-4 p-0">
        <SikkaCardHeader title={"Account Information"} />
        <CardBody>
          <Row className="fs--1">
            <Col lg xxl={5}>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">Full Name:</p>
                </Col>
                <Col>
                  <p className="mb-2 fst-italic">{partnerDetails.partner_name}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">Email:</p>
                </Col>
                <Col>
                  <a href={"apidemo@sikkasoftware.com" && "mailto:"}>
                    <p className="mb-2 fst-italic">{partnerDetails.username}</p>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">Address:</p>
                </Col>
                <Col>
                  <p className="mb-2 fst-italic">{partnerDetails.dev_address}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">City:</p>
                </Col>
                <Col>
                  <p className="mb-2 fst-italic">{partnerDetails.dev_city}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">State:</p>
                </Col>
                <Col>
                  <p className="mb-2 fst-italic">{partnerDetails.dev_state}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">Zip Code:</p>
                </Col>
                <Col>
                  <p className="mb-2 fst-italic">{partnerDetails.dev_zip}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">Country:</p>
                </Col>
                <Col>
                  <p className="mb-2 fst-italic">{partnerDetails.dev_country}</p>
                </Col>
              </Row>
            </Col>
            <Col lg xxl={{ span: 5, offset: 1 }} className="mt-4 mt-lg-0">
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">SCRM Account ID:</p>
                </Col>
                <Col>
                  <p className="mb-2 fst-italic">--</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">Master Customer ID:</p>
                </Col>
                <Col>
                  <p className="mb-2 fst-italic">{partnerDetails.master_customer_id}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">Contact Person Name:</p>
                </Col>
                <Col>
                  <p className="mb-2 fst-italic">{partnerDetails.dev_name}</p>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">Contact Person Phone:</p>
                </Col>
                <Col>
                  <a href={"(992) 566-9159" && "tel:"}>
                    <p className="mb-2 fst-italic">{partnerDetails.dev_phone}</p>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-1">Contact Person Email:</p>
                </Col>
                <Col>
                  <a href={"apidemo@sikkasoftware.com" && "mailto:"}>
                    <p className="mb-2 fst-italic">{partnerDetails.username}</p>
                  </a>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={5}>
                  <p className="font-weight-bold mb-2">Logo:</p>
                </Col>
                <Col>
                  <FalconLightBox image={partnerDetails.partner_logo}>
                    <Image src={partnerDetails.partner_logo} fluid rounded width={200} />
                  </FalconLightBox>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default AccountInformation;
